import { compose, isNil, ifElse, is, split, head, unless } from "ramda";

export const stripQuery = ifElse(
  is(String),
  compose(head, split("?")),
  unless(isNil, () => {
    throw new TypeError("Invalid argument, must be a string");
  })
);
